// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z-8I","content":"styles_content__HVAMt"};